module.exports = __webpack_public_path__ + "img/6-sateenkaaren-taa.f4593549.jpg";